import one360 from './one360';

export async function uploadDocumentImage(
  phaseId: string,
  documentId: string,
  imageData: string,
  fileName: string,
): Promise<string | void> {
  const lastDash = phaseId.lastIndexOf('-');
  const dealId = lastDash !== -1 ? phaseId.substring(0, lastDash) : phaseId;

  const formData = new FormData();
  const base64Response = await fetch(imageData);
  const blob = await base64Response.blob();
  formData.append('File', blob, fileName);
  formData.append('DocumentId', documentId);

  const response = await one360.post<{ fileId?: string; FileId?: string }>(
    `/api/v1/ops/projects/${encodeURIComponent(dealId)}/documents`,
    formData,
  );

  return response.fileId ?? response.FileId;
}

export async function deleteProjectDocument(phaseId: string, documentId: string): Promise<void> {
  const lastDash = phaseId.lastIndexOf('-');
  const dealId = lastDash !== -1 ? phaseId.substring(0, lastDash) : phaseId;
  await one360.delete(`/api/v1/ops/projects/${encodeURIComponent(dealId)}/documents/${encodeURIComponent(documentId)}`);
}
